/**
 * Error wrapper class for catching MSAL error.
* */
export default class InteractiveSignInRequired extends Error {
}
